<template>
  <div id="about">
    
        <top-nav :show-user="true" />
  <div class="inner-content">
    <empty-state view-style="circleBg" button-text="HOME" :has-content="true" data-icon="report_problem" view-size="small" :show-button="true" @action="$_backToHome">
    
  <template #header> Nothing here yet</template>
  <template #content>Currently under construction</template>
    </empty-state>
  </div>
  <app-bottom-tab />
    
  </div>
</template>
<script>
import emptyState from '@/components/emptyState.component'
import topNav from '@/components/topNav'
import AppBottomTab from '@/components/AppBottomTab'
export default {
  name: "About",
  props: {},
  data() {
    return {};
  },
   components: {
    topNav,
    emptyState,
    AppBottomTab
  },
  mounted() {},
  computed: {},
  methods: {
    $_backToHome(e) {
     this.$router.push({name:'Home'})
    }
  },
};
</script>
<style lang="scss" scoped>
#about {
 .inner-content {
    padding: 24px 24px 68px;
  min-height: calc(100vh - 120px);
 }
}
</style>
